import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from "../../../../providers/appProvider"

import Modal from '../../../UI/Modal/Modal'
import Attachment from "../../../../assets/Icon/Attachment"; 
import tbl from '../../../../assets/Style/Table.module.css' 
import paycl from './BankModal.module.css'
 import Remove from "../../../../assets/Icon/Remove";
import { useUpdateEffect } from '../../../../hooks/useUpdateEffect';
import { useBank } from '../../../../hooks/useBank';
import { baseFileURL } from '../../../../Api';

const BankModal = ({container,  containerService}) => {

    const { appState, app } = useContext(AppContext);


    const formatDate = (dateString) => {

        const purchasedAtDate = new Date(dateString);

        const months = [
            "იან",
            "თებ",
            "მარ",
            "აპრ",
            "მაი",
            "ივნ",
            "ივლ",
            "აგვ",
            "სექ",
            "ოქტ",
            "ნოე",
            "დეკ"
        ];

        const day = purchasedAtDate.getDate();
        const month = months[purchasedAtDate.getMonth()];
        const year = purchasedAtDate.getFullYear();

        return `${day} ${month}  ${year}`;
    };

    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [isDealer, setIsDealer] = useState(false);
    const [file, setFile] = useState("null");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const {bankService} = useBank()

 
    const [newBank, setNewBank] = useState({
        bank: 0,
        name: "",
        container_id: container.id,
        type_id: 0,
    })

    const [validates, setValidates] = useState({})

    const validateBank = (bank) => {
        const messages = {};

        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };


    const [banks, setBanks] = useState([])

    const fetchBanks = () => {
        bankService.fetchByContainerId(container.id)
            .then(banks => {
                setBanks(banks)
            })
            .catch(error => { 
            });
    }

    useEffect(() => {
        fetchBanks()
        if (isModalOpen) {
            fetchBanks()
        }
    }, [isModalOpen]);
 
    useUpdateEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateBank(newBank)
        }
    }, [newBank]);

    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }

    const handleChange = (event) => {
        var val = ""

        if (event.target.name === "bank") {
            val = convertToInt(event.target.value);
        } else {
            val = event.target.value
        }
 
        setNewBank({
            ...newBank,
            [event.target.name]: val
        });
    };

 

    const handleFocus = (e) => {
        if (e.target.value === '0') {
            setNewBank({
                ...newBank,
                bank: ""
            });
        }
    };

    const handleBlur = (e) => {
        if (e.target.value === '') {
            let val = convertToInt(0);
            setNewBank({
                ...newBank,
                bank: val
            });
        };
    };


    const openModal = () => {
        setValidates({})
        setNewBank({
            ...newBank,
            bank: 0,
            description: "",
            container_id: container.id,
            type_id: 2,
        });
        setIsModalOpen(true)
 
    }

    const onAdd = () => {
        const newForm = new FormData();

        for (let key in newBank) {
            newForm.append(key, newBank[key]);
        }

        newForm.append('doc', file);

        const isValidate = validateBank(newBank)

        if (isValidate === true) {
            bankService.addBankContainer(newForm)
                .then(response => {
                    //fetchBanks()
                    containerService.fetchList()

                })
                .catch(error => {
                    console.error(error);
                });

            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true)
        }
    }
 
    const onRemove = (bankId) => {
        bankService.removeBank(bankId)
            .then(response => {
                fetchBanks()
                containerService.fetchList() 
            })
            .catch(error => {
                console.error(error);
            });
    }


    let doneclass = ' '


    return (
        <>

 
            {banks.length > 0 ? (
                <div className={paycl.invoicebtn + ' ' + paycl.green} onClick={() => { openModal() }} >
                    <Attachment /> ინვოისები <span>{banks.length}</span> 
                </div>
            ) : (
                <div className={paycl.invoicebtn} onClick={() => { openModal() }} >
                    <Attachment /> ინვოისები
                </div>
            )}
  

            <Modal isOpen={isModalOpen} size="medium" onClose={() => setIsModalOpen(false)}>

                <div className={paycl.modalHead} >
                    <h3>
                        <span className={paycl.iconHead} > <Attachment /></span>

                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ lineHeight: 1, fontSize: '14px', fontWeight: 600 }}>ინვოისები</div>    
                            <div style={{ lineHeight: 1, fontSize: '14px', fontWeight: 600, marginTop: '5px' }}> {container.name}</div>    
                        </div>
                         
                    </h3>
                </div>

                <div>
                    <div className={tbl.table + ' ' + paycl.table} style={{ minHeight: 'unset' }}>

                        <table>
                            <thead>
                                <tr>
                                    <th className={paycl.id}>#</th>
                                    <th>ინვოისი</th> 
                                    <th>ფაილი</th>
                                    <th>თარიღი</th> 
                                    <th>მომხმარებელი</th>
                                    <th className={paycl.btntbl}> </th>
                                </tr>
                            </thead>
                            <tbody>

                                {banks.map((bank, index) =>
                                    <tr>
                                        <td className={paycl.id}>{index + 1}</td>
                                        <td> {bank.name}</td>
                                        <td>
                                            {
                                                bank.doc === 'null' || bank.doc &&
                                                <a href={baseFileURL + bank.doc} target='_blank' rel="noopener noreferrer">
                                                    ფაილი
                                                </a>
                                            }
                                        </td>
                                        <td> {formatDate(bank.created_at)} </td>
                                     

                                        <td> 
                                        {bank.user ? (
                                            <span>{bank.user.firstname} {bank.user.lastname}</span>
                                        ) : (
                                            <span>N/A</span>
                                        )}
                                        </td>

                                        <td className={paycl.btntbl}>
                                            {app.hasPermission("INVOICE_DELETE") &&
                        
                                                <div className={paycl.btns}>
                                                    <div>
                                                        <span className={paycl.removeBtn} onClick={() => onRemove(bank.id)} ><Remove /> წაშლა</span>
                                                    </div>
                                                </div>
                                            }
                                        </td>

                                    </tr>
                                )}
                            </tbody>
                        </table>

 
                    </div>
                    {app.hasPermission("INVOICE_ADD") &&
                                                  

                        <div className={paycl.formField}>

                            <legend>ინვოისის დამატება</legend>

                            <div className={paycl.row}> 
    
                                <div style={{ width: '100%' }}> 
                                    <div className={paycl.uploadDiv}>
                                        <input type="file" name="doc" onChange={e => setFile(e.target.files[0])} />
                                    </div>
                                </div> 
                                {validates && validates.bank ? validates.bank.message : ""}
    
                                <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '15px'}}> 
                                    <label htmlFor="name">ინვოისის ID</label>                                      
                                    <input type="text" className={paycl.input} name="name"  onChange={handleChange} value={newBank.name} /> 
                                </div>

                            </div>

                            <div className={paycl.addBox}>
                                <span onClick={onAdd} className={paycl.addBtn}>დამატება</span>
                            </div>

                        </div>

                    } 
                </div>
            </Modal>
        </>
    );
};

export default BankModal;